// extracted by mini-css-extract-plugin
export default {"digit":"Digit_digit__ly6aJ"};